import type {
  GetOrganizationSecurityFocusEventsRequest,
  GetOrganizationSecurityFocusRequest,
  GetOrganizationSecurityFocusesRequest,
  GetOrganizationSpidrRequest,
  GetOrganizationSpidrAttachmentLinkRequest,
  GetOrganizationSpidrSummaryRequest,
  GetOrganizationRequest,
  GetOrganizationSpidrBlueprintsRequest,
} from '@rtkwlf/track-public';

import { QUERY_KEY_CONSTANTS } from './query-key-constants';
import type { Pod } from './types';

/* prettier-ignore */
export const queryKeys = {
  filters: {
    spidrs: (pod: Pod) =>
        [pod, QUERY_KEY_CONSTANTS.FILTERS, QUERY_KEY_CONSTANTS.SPIDRS],
  },
  organizations: {
    id: {
      index:(pod: Pod, params: GetOrganizationRequest) =>
        [pod, QUERY_KEY_CONSTANTS.ORGANIZATIONS, params.orgID],
      focuses: {
        id: {
          index: (pod: Pod, params: GetOrganizationSecurityFocusRequest) =>
        [pod, QUERY_KEY_CONSTANTS.ORGANIZATIONS, params.orgID, QUERY_KEY_CONSTANTS.FOCUSES, params.focusID],
          events: (pod: string, params: GetOrganizationSecurityFocusEventsRequest) => [pod, QUERY_KEY_CONSTANTS.ORGANIZATIONS, params.orgID, QUERY_KEY_CONSTANTS.FOCUSES, params.focusID, QUERY_KEY_CONSTANTS.EVENTS]
        },
        index: (pod: Pod, params: GetOrganizationSecurityFocusesRequest) => [pod, QUERY_KEY_CONSTANTS.ORGANIZATIONS, params.orgID, QUERY_KEY_CONSTANTS.FOCUSES]
      },
      spidrs: {
        id: {
          index: (pod: Pod, params: GetOrganizationSpidrRequest) => [pod, QUERY_KEY_CONSTANTS.ORGANIZATIONS, params.orgID, QUERY_KEY_CONSTANTS.SPIDRS, params.spidrID],
          summary: (pod: Pod, params: GetOrganizationSpidrSummaryRequest) => [pod, QUERY_KEY_CONSTANTS.ORGANIZATIONS, params.orgID, QUERY_KEY_CONSTANTS.SPIDRS, params.spidrID, QUERY_KEY_CONSTANTS.SUMMARY],
          attachments: {
            id: (pod: Pod, params: GetOrganizationSpidrAttachmentLinkRequest) => [pod, QUERY_KEY_CONSTANTS.ORGANIZATIONS, params.orgID, QUERY_KEY_CONSTANTS.SPIDRS, params.spidrID, QUERY_KEY_CONSTANTS.ATTACHMENTS, params.attachmentID]
          },
        },
      },
      spidrblueprints: {
        index: (pod: Pod, params: GetOrganizationSpidrBlueprintsRequest) => [pod, QUERY_KEY_CONSTANTS.ORGANIZATIONS, params.orgID, QUERY_KEY_CONSTANTS.SPIDR_BLUEPRINTS], 
      } 
    },
  },
};
